/**
 * «Войти как водитель» on a driver invite is an answer, not just a way to sign in.
 *
 * Signing in through Яндекс or VK ID always produces a manager account: both identity providers in
 * Keycloak hand out `manager` through a hardcoded-role mapper and know nothing about the invite.
 * The person then came back to the trip only to be asked «Продолжить как водитель?» — a question
 * they had answered one screen earlier by pressing the button that says exactly that. Remembering
 * the press lets the invite page open the driver cabinet by itself.
 *
 * Only the press is remembered, never the invite: the code grants access to a trip and already
 * travels in the URL. Someone who opens an invite while ALREADY signed in as a manager never
 * presses the button, so for them the page still asks — that is a person with a working cabinet,
 * and the link may have reached them by mistake.
 *
 * sessionStorage, because the flag must survive the Keycloak round trip and the full reload after
 * the 152-ФЗ consent (ConsentGate), and must not outlive the tab.
 */

const KEY = 'lupa.driverInviteSignIn'

export function rememberDriverSignIn(): void {
  try {
    sessionStorage.setItem(KEY, '1')
  } catch {
    // Private mode — the invite page will simply ask once more.
  }
}

export function hasDriverSignIn(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function forgetDriverSignIn(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // Nothing stored, nothing to forget.
  }
}
